import { KibGrid, KibGridItem } from '@chewy/kib-layout-react'
import classNames from 'classnames'

import CommunicationHeaderActionButtons from './CommunicationHeaderActionButtons'

import '@chewy/kib-layout-styles/dist/styles/kib-grid.css'
import styles from './SnapshotHeader.module.scss'

const SnapshotHeader = ({
  isExpanded,
  name,
  showNoItems,
  onExpand,
}: {
  isExpanded?: boolean
  name: string
  onExpand: () => void
  showNoItems: boolean
}) => {
  if (isExpanded) {
    return null
  }
  return (
    <KibGrid
      className={classNames(styles.communicationSnapshotHeader, {
        [styles.bottomBorder]: showNoItems,
      })}
      valign="center"
    >
      <KibGridItem className={styles.widgetName}>{name}</KibGridItem>
      <CommunicationHeaderActionButtons
        isExpanded={isExpanded}
        onExpand={onExpand}
      />
    </KibGrid>
  )
}
export default SnapshotHeader
